import Button from '@/common/components/base/button/Button';
import LoadingButton from '@/common/components/base/button/loadingButton';
import MainModal from '@/common/components/base/modal/Modal';
import Typography from '@/common/components/base/typography/Typography';
import { RemoveWagesModalType } from '@/modules/adjusterReportModules/IncidentParticipants/components/modals/WagesModal.type';
import React from 'react';
import { Box, Flex } from 'styled-system/jsx';
import CloseIcon from '@/common/assets/icons/redCloseIcon.svg?react';
import { useParams } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { deletePropertyWagesQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/deleteWages/deleteWagesQueryOptions';

const RemoveWagesModal: React.FC<RemoveWagesModalType> = ({
  wagesName,
  removeModal,
  setRemoveModal,
  wagesId,
  completeRemove,
}) => {
  const { id, damagedId } = useParams();
  const { mutate: deleteWages, isPending: loading } = useMutation({
    ...deletePropertyWagesQueryOptions(),
    onSuccess: () => {
      completeRemove && completeRemove();
      setRemoveModal(false);
    },
  });
  const removeWagesHandler = () => {
    deleteWages({
      id: +id!,
      wages_id: wagesId,
      damaged_id: +damagedId!,
    });
  };

  return (
    <MainModal open={removeModal} closeModal={() => setRemoveModal(false)}>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        gap={16}
        width="100%"
      >
        <CloseIcon />
        <Typography
          textStyle="b2"
          color="black-1"
          mt={7}
        >{`آیا از حذف نوع تعمیر " ${wagesName} " مطمئن هستید؟`}</Typography>
        <Flex justifyContent="space-between" width="100%" gap={8} mt={34}>
          <Box flex={1}>
            <Button
              fullWidth
              variant="outlined"
              color="common"
              onClick={() => setRemoveModal(false)}
            >
              انصراف
            </Button>
          </Box>
          <Box flex={1}>
            <LoadingButton
              fullWidth
              variant="contained"
              color="danger"
              loading={loading}
              onClick={() => removeWagesHandler()}
            >
              حذف
            </LoadingButton>
          </Box>
        </Flex>
      </Box>
    </MainModal>
  );
};
export default RemoveWagesModal;
